// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectHeader__projectHeader___UWZ2C {
    padding: var(--space-2xs);
    background: var(--color-bg-secondary);
    border-bottom: 0.1rem solid var(--color-bg-border);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/Header/ProjectHeader.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,kDAAkD;AACtD","sourcesContent":[".projectHeader {\n    padding: var(--space-2xs);\n    background: var(--color-bg-secondary);\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectHeader": `ProjectHeader__projectHeader___UWZ2C`
};
export default ___CSS_LOADER_EXPORT___;
